import {forwardRef} from 'react';
import {BleskIconProps} from '../types';

export const MobileIcon = forwardRef<SVGSVGElement, BleskIconProps>(function BaseIcon(
  {...rest},
  ref,
) {
  return (
    <svg {...rest} ref={ref} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.0156 46.6673H34.989"
        stroke="#475069"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.3359 11.334L52.6693 52.6673"
        stroke="#475069"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.6641 29.334V48.0007C18.6641 50.9473 21.0507 53.334 23.9974 53.334H39.9974C42.9441 53.334 45.3307 50.9473 45.3307 48.0007V45.334"
        stroke="#475069"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.6641 18.666V15.9993C18.6641 13.0527 21.0507 10.666 23.9974 10.666H39.9974C42.9441 10.666 45.3307 13.0527 45.3307 15.9993V34.666"
        stroke="#475069"
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
});
